<template>
  <div class="l-page l-page--step-result-list">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->

    <main class="l-main l-main--flex">
      <div class="l-main-head">
        <h2 class="c-title u-w100p">
          <div class="c-title__text c-title__text--blue u-fs34">シナリオ配信の配信成果</div>
        </h2>
      </div>
      <div class="l-main-content">
        <div class="p-step-result">
          <div class="p-step-result__data" :class="{'is-loading': isLoading, 'is-empty': isEmpty}">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--abtest">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w140 is-sortable">
                    <span class="c-table__text">配信日時</span>
                    <sort-switch name="deliverDate" :order="sortTargets.deliverDate" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center is-sortable">
                    <span class="c-table__text">シナリオ名</span>
                    <span class="c-btn c-btn--sort" data-type="title"></span>
                    <sort-switch name="scenarioName" :order="sortTargets.scenarioName" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w100">
                    <span class="c-table__text">ステップ数</span>
                  </th>
                  <th class="c-table__cell--center u-w140 is-sortable">
                    <span class="c-table__text">インプレッション</span>
                    <sort-switch name="impression" :order="sortTargets.impression" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w140 is-sortable">
                    <span class="c-table__text">クリック数</span>
                    <sort-switch name="click" :order="sortTargets.click" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w120">
                    <span class="c-table__text">クリック率(%)</span>
                  </th>
                </tr>
              </thead>
              <tbody v-if="scenarios">
                <step-result-item
                  v-for="(scenario,index) in scenarios.data"
                  :key="index"
                  :scenario="scenario"
                  :step-info="stepInfo"
                  @show-click="onShowClick"
                />
              </tbody>
            </table>
            <pagination v-if="paginationInfo" :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    csrfToken: String,
    stepInfo: Object,
  },
  data() {
    return {
      sortTargets: {
        deliverDate: 1,
        scenarioName: 0,
        impression: 0,
        click: 0,
      },
      scenarios: null,
      paginationInfo: null,
      isLoading: false,
      isEmpty: false,
      isError: false,
      errorMessage: '',
      currentScenarioName: null,
    }
  },
  mounted: function() {
    import('../../funcs/pages/step-result-list').then(module => {
      module.StepResultList();
    });
    this.loadData();
  },
  methods: {
    loadData: function () {
      // ソート情報を抽出
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if (this.sortTargets[workTarget] != 0) {
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      // 情報取得用パラメタ作成
      const params = {
        params: {
          sort: sortTarget,
          order: order,
          page: this.page,
        }
      };

      // ローダー表示設定
      this.isLoading = true;

      // 配信結果データの取得処理実行
      axios.get('/api/scenario/result-list', params)
        .then(res => {
          if (res.data.scenarios.data){
            this.scenarios = res.data.scenarios;
            this.paginationInfo = res.data.scenarios;
          }
          setTimeout(() => {
            this.isLoading = false;
            if (res.data.scenarios.data.length < 1) this.isEmpty = true;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          setTimeout(() => {
            this.isError = true;
            this.errorMessage = 'シナリオ配信結果一覧の取得時にエラーが発生しました'
            this.isLoading = false;
          }, 300);
        });
    },
    onPageClick: function (clickPage) {
      this.page = clickPage;
      this.loadData();
    },
    onShowClick: function (scenarioId) {
      location.href = this.stepInfo.resultUrl + '?scenario_id=' + scenarioId;
    },
    onSortButtonClick: function (target) {
      this.currentSortTarget = target;
      if (!this.sortTargets[target] || (this.sortTargets[target] == -1)) {
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if (workTarget != target) {
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },

  }
}
</script>
